import axios from "axios";
import Cookies from "js-cookie";

// Create the API client
const apiClient = axios.create({
  baseURL: "https://nn.drife.dev",
  headers: {
    "Content-Type": "application/json",
  },
});

const setAuthorizationHeader = async () => {
  try {
    const accesstoken = Cookies.get("accesstoken");
    if (accesstoken) {
      apiClient.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${accesstoken}`;
    }
  } catch (error) {
    console.error("Failed to set authorization header:", error);
  }
};

// Call the function to set the header
setAuthorizationHeader();

export default apiClient;
